
<ng-container *ngIf="form != undefined">
    <div [formGroup]="form" class="general">
        <div class="button-area">
            <button class="btn-primary" [ngStyle]="objColor" (click)="setFormValue()">{{title_button}}</button>
        </div>
    </div>
</ng-container>